angular.module('elfium').filter('taskSplitByType', ['TASK_TYPES', function (TASK_TYPES) {
    var that = this;
    return function (tasks) {
        var tasksByType = {};
        angular.forEach(TASK_TYPES, function (taskType) {
            tasksByType[taskType] = [];
            angular.forEach(tasks, function (task) {
                if (task.typ == taskType) {
                    tasksByType[taskType].push(task);
                }
            });
        });
        return tasksByType;        
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskSplitByTypeFilter.ts